import * as React from 'react';
import { AddressMapDisplay } from '../../../transportation/components/mapping/AddressMapDisplay';
import { AppUtils } from '../../../utils/app-utils';
import { TextInput } from '../../../components/form-elements/_index';

interface IProps {
    name                    : string;
    addressLine1            : string;
    addressLine2            : string;
    city                    : string;
    stateProvince           : string;
    postalCode              : string;
    phoneNumber?            : string;
    latitude?               : number;
    longitude?              : number;
    onClick?                : any;
    phoneNumberChanged?     : any;
    nameChanged?            : any;
    addressLine1Changed?    : any;
    addressLine2Changed?    : any;
    cityChanged?            : any;
    stateChanged?           : any;
    postalCodeChanged?      : any;
    errorMsgs?              : any;
}

export const AddressEntryDisplay = (props: IProps) => {

    const line1 = props.addressLine1 ? props.addressLine1.replace(' ', '+') : '';
    const city = props.city ? props.city.replace(' ', '+') : '';
    const state = props.stateProvince ? props.stateProvince.replace(' ', '+') : '';
    const zip = props.postalCode ? props.postalCode.replace(' ', '+') : '';
    const latlng = {
        lat: props.latitude,
        lng: props.longitude
    };

    const urlAddr = `${line1},+${city},+${state}+${zip}`;

    const _onPhoneNumberChanged = (evt: any) => {
        props.phoneNumberChanged(evt);
    };

    const _onNameChanged = (evt: any) => {
        props.nameChanged(evt);
    };

    const _onAddressLine1Changed = (evt: any) => {
        props.addressLine1Changed(evt);
    };

    const _onAddressLine2Changed = (evt: any) => {
        props.addressLine2Changed(evt);
    };

    const _onCityChanged = (evt: any) => {
        props.cityChanged(evt);
    };

    const _onStateChanged = (evt: any) => {
        props.stateChanged(evt);
    };

    const _onPostalCodeChanged = (evt: any) => {
        props.postalCodeChanged(evt);
    };

    return props
            ? <div className="row">
                <div className="col-md-12">
                    <div className="edit-delivery-address">
                        <div className="row">
                            <div className="col-md-6">
                                <TextInput
                                    type="text"
                                    id="address-name"
                                    label="Name"
                                    error={ props.errorMsgs?.name }
                                    value={ props.name }
                                    onChange={ _onNameChanged }
                                />
                            </div>
                            <div className="col-md-6">
                            </div>

                            <div className="col-md-6">
                                <TextInput
                                    type="text"
                                    id="addressLine1"
                                    label="Address Line 1"
                                    error={ props.errorMsgs?.addressLine1 }
                                    value={ props.addressLine1 }
                                    onChange={ _onAddressLine1Changed }
                                />

                                <TextInput
                                    type="text"
                                    id="addressLine2"
                                    label="Address Line 2"
                                    value={ props.addressLine2 }
                                    onChange={ _onAddressLine2Changed }
                                />

                                <TextInput
                                    type="text"
                                    id="city"
                                    label="City"
                                    error={ props.errorMsgs?.city }
                                    value={ props.city }
                                    onChange={ _onCityChanged }
                                />
                            </div>

                            <div className="col-md-6">
                                <TextInput
                                    type="text"
                                    id="state"
                                    label="State"
                                    error={ props.errorMsgs?.stateProvince }
                                    value={ props.stateProvince }
                                    onChange={ _onStateChanged }
                                />

                                <TextInput
                                    type="text"
                                    id="postalCode"
                                    label="Postal Code"
                                    error={ props.errorMsgs?.postalCode }
                                    value={ props.postalCode }
                                    onChange={ _onPostalCodeChanged }
                                />

                                <TextInput
                                    id="address-phone"
                                    label="Phone Number"
                                    type="text"
                                    value={`tel: ${AppUtils.formatPhone(props.phoneNumber ?? '')}`}
                                    onChange={ _onPhoneNumberChanged }
                                />
                            </div>
                        </div>

                        <div className="form-group address-display">
                            <div className="col-md-6">
                                <div className="location">
                                    {
                                        (props.latitude && props.longitude) || urlAddr.length > 5
                                            ? <AddressMapDisplay
                                                onClick={ props.onClick }
                                                center={ latlng } />
                                            : <div className="no-address">Unable to load address</div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
            : null;

};
